import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import PlusIcon from "app/components/Icons/PlusIcon";
import { ChevronRightIcon } from "lucide-react";
import { GroupAction } from "../../../../types";
import React from "react";


interface Props{
    onAction: (type: GroupAction) => void
}
export default function AddGroupSubMenu({ onAction }:Props) {
  return (
    <DropdownMenu.Sub>
      <DropdownMenu.SubTrigger className="flex items-center gap-2 px-4 py-2 rounded hover:bg-gray-100">
        <PlusIcon size={20} />
        Add Group
        <ChevronRightIcon className="ml-auto size-4" />
      </DropdownMenu.SubTrigger>

      <DropdownMenu.Portal>
        <DropdownMenu.SubContent className="bg-white rounded shadow-md p-2">
          <DropdownMenu.Item
            onClick={() => onAction(GroupAction.ADD)}
            className="flex gap-2 px-4 py-2 rounded hover:bg-gray-100"
          >
            <PlusIcon size={20} />
            New Group
          </DropdownMenu.Item>
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  );
}
